const buildEntityToNameLookup = (dimension_list) => {
  const lookup = {};
  dimension_list.forEach((member) => {
    lookup[member.entity_id] = member.name;
  });
  return lookup;
};
export default buildEntityToNameLookup;
